export const PC_PASSWORD = "NALA"; // mot de passe de session (J2 + J6)
export const FOLDER_PASSWORD = "MIRAGIO"; // mot de passe du dossier critique (J1)// Mot de passe de la boîte (nom du chien de Samir, donné par J2)
export const BOX_PASSWORD = "BALTHAZAR";